export default __webpack_public_path__ + "static/gta_roofing_6-84677b0424a53cfcd14a532b791a2f17.jpg";